'use client';

import React, { forwardRef } from 'react';
import { cn } from '@/components/ui/_lib/cn';
import type { UiSkeletonProps } from '@/components/ui/_lib/skeletonProps';
import { useDeferredSkeleton } from '@/components/ui/_lib/useDeferredSkeleton';
import { SkeletonLines } from '@/components/ui/_lib/SkeletonLines';
import { SKELETON_BY_COMPONENT } from '@/components/ui/_lib/skeletonRegistry';

const sk = SKELETON_BY_COMPONENT.H1;

export type H1Props = React.HTMLAttributes<HTMLHeadingElement> & {
  'aria-label'?: string;
  'aria-labelledby'?: string;
} & UiSkeletonProps;

const H1 = forwardRef<HTMLHeadingElement, H1Props>((props, ref) => {
  const {
    skeleton = false,
    skeletonMaxWaitMs = 2000,
    skeletonLines,
    className,
    children,
    ...domProps
  } = props;

  const showSkeleton = useDeferredSkeleton(skeleton, skeletonMaxWaitMs);

  return (
    <h1
      ref={ref}
      className={cn('group', 'h1', className)}
      {...domProps}
    >
      <SkeletonLines show={showSkeleton} shape={sk.shape} lines={skeletonLines ?? sk.lines}>
        {children}
      </SkeletonLines>
    </h1>
  );
});

H1.displayName = 'H1';

export default H1;
